import React from 'react'
import { Wrap } from './container.style'

const Container = ({ wide, children }) => {
  return <Wrap wide={wide}>{children}</Wrap>
}

export default Container
